import { __decorate, __metadata } from "tslib";
import { Vue, Component, Inject } from 'vue-property-decorator';
import { ReCaptchaVerification, GEETEST_TYPE, GOOGLE_TYPE } from '@patsnap-utils/captcha-verification';
import { GOOGLE_CAPTCHAID_INVISIBLE, GEETEST_MESSAGEAUTHENTICATION } from 'library-components/config/envConfig';
import { GOOGLE_ERROR_MESSAGE, GEETEST_ERROR_MESSAGE, CLOSE } from 'library-components/apis/passport/error';
let ReCaptchaVerificationMixin = class ReCaptchaVerificationMixin extends Vue {
    commonService;
    /**
     * 非中国服务器  google
     * @returns
     */
    async geetestValidate() {
        try {
            const resGeetestValidate = await this.captchaVerification.captchaValidate();
            return resGeetestValidate;
        }
        catch (e) {
            if (e.type === CLOSE) {
                return CLOSE;
            }
            if (!this.commonService.IsRegionCN) {
                return GOOGLE_ERROR_MESSAGE;
            }
            return GEETEST_ERROR_MESSAGE;
        }
    }
    captchaVerification = '';
    mounted() {
        // 国内 geetest  国外google
        const type = this.commonService.IsRegionCN ? GEETEST_TYPE : GOOGLE_TYPE;
        const id = this.commonService.IsRegionCN ? GEETEST_MESSAGEAUTHENTICATION : GOOGLE_CAPTCHAID_INVISIBLE;
        this.captchaVerification = new ReCaptchaVerification({
            type,
            id,
            lang: this.$i18n.locale,
            obj: { outside: false },
        });
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], ReCaptchaVerificationMixin.prototype, "commonService", void 0);
ReCaptchaVerificationMixin = __decorate([
    Component
], ReCaptchaVerificationMixin);
export { ReCaptchaVerificationMixin };
